import ActiveHealthPolicyManagementTable from './ActiveHealthPolicyManagementTable'

export default ActiveHealthPolicyManagementTable
